import {
    MDBNavbar,
    MDBNavbarBrand,
    MDBIcon,
    MDBNavbarNav,
    MDBDropdown,
    MDBDropdownToggle,
    MDBNavbarItem,
    MDBContainer,
} from "mdbreact"
import TopSearchTextField from "./TopSeachBar/TopSearchTextBox"

const TopNavigation = ({
    toggle,
    onSideNavToggleClick,
    userInfo,
    selectedRegion,
    openSettingsDialog,
}: {
    toggle: boolean
    onSideNavToggleClick: any
    userInfo: any
    selectedRegion: any
    openSettingsDialog: any
}) => {
    const brandStyle = {
        padding: "0px",
    }
    const iconStyle = {
        width: "44px",
    }
    const regionStyle = {
        transition: "padding-left .3s",
        display: "flow-root",
        fontSize: "16px",
    }

    return (
        <>
            <MDBNavbar className="flexible-MDBNavbar" light bgColor="light" expand="md" fixed="top" style={{zIndex: 3}}>
                <MDBContainer fluid>
                    <MDBNavbarBrand href="/" style={brandStyle}>
                        <img alt="" src="/volvo-logo.png" style={iconStyle}></img>
                    </MDBNavbarBrand>
                    <MDBNavbarBrand style={regionStyle}>
                        <p className="mb-0 font-weight-bold text-muted" style={{fontSize: "1rem", lineHeight: 1}}>
                            Volvo Trucks
                        </p>
                        <p
                            className="mb-0"
                            style={{
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                letterSpacing: "-.1px",
                                lineHeight: "1.5",
                                textTransform: "uppercase",
                            }}
                        >
                            UNITED KINGDOM & IRELAND
                        </p>
                    </MDBNavbarBrand>
                    <MDBContainer fluid>
                        <MDBNavbarNav fullWidth className="ms-auto mb-2 mb-lg-0">
                            <div className="me-auto"></div>
                            <TopSearchTextField />
                            <div className="me-auto"></div>
                        </MDBNavbarNav>
                    </MDBContainer>
                    <MDBNavbarNav right fullWidth={false} className="d-flex flex-row">
                        <MDBNavbarBrand style={{...regionStyle, textAlign: "right"}}>
                            <p
                                className="mb-0 font-weight-bold text-muted"
                                style={{
                                    fontSize: "0.75rem",
                                    letterSpacing: "-.1px",
                                    lineHeight: "1.5",
                                    textTransform: "uppercase",
                                    fontWeight: "bold",
                                }}
                            >
                                {selectedRegion.regionName}
                            </p>
                            <p className="mb-0" style={{fontSize: "12px"}}>
                                {userInfo && userInfo.username}
                            </p>
                        </MDBNavbarBrand>
                        <MDBNavbarItem>
                            <MDBDropdown>
                                <MDBDropdownToggle
                                    onClick={() => {
                                        openSettingsDialog(true)
                                    }}
                                    style={{cursor: "pointer"}}
                                    tag="a"
                                    className="nav-link hidden-arrow d-flex align-items-center mt-2"
                                >
                                    <MDBIcon fas icon="user-alt" />
                                </MDBDropdownToggle>
                            </MDBDropdown>
                        </MDBNavbarItem>
                    </MDBNavbarNav>
                </MDBContainer>
            </MDBNavbar>
            <MDBNavbar light expand="md" fixed="top" className="app-title-header">
                <div
                    onClick={() => {
                        onSideNavToggleClick()
                    }}
                    key="sideNavToggleA"
                    style={{
                        lineHeight: "32px",
                        margin: "0rem 1rem",
                        verticalAlign: "middle",
                        alignItems: "center",
                        cursor: "pointer",
                    }}
                >
                    <MDBIcon icon={toggle ? "times" : "bars"} style={{width: "20px"}} size="lg" />
                </div>
                <MDBNavbarBrand style={regionStyle}>Annual Inspections</MDBNavbarBrand>
            </MDBNavbar>
        </>
    )
}

export default TopNavigation
